<template>
    <div class="nasabah">
        <p class="title">Audit Trail</p>
        <div class="content">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Nama Nasabah</th>
                        <th>Status Nasabah</th>
                        <th>Tanggal Pendaftaran</th>
                        <th>Nama Penerima</th>
                        <th>Tanggal Verifikasi</th>
                        <th>Informasi Lainnya</th>
                        <!-- <th>Action</th> -->
                    </tr>
                </thead>
                <tbody>
                    <td colspan="9" v-show="loadingData" style="text-align: center">
                        <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </td>
                    <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false && dataNsb.length != 0">
                        <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                        <td>{{ data.fullname }}</td>
                        <td>{{ data.status }}</td>
                        <td>{{ data.created_at | formatDateTimeFull }}</td>
                        <td>
                            {{ data.operator_id.fullname }}
                        </td>
                        <td>{{ data.updated_at | formatDateTimeFull }}</td>
                        <!-- <td>{{ data.newInfo ? data.newInfo.geoplugin_request + " - " + data.newInfo.geoplugin_city : "-" }}</td> -->
                        <td class="text-center">
                            <button type="button" class="buttons btn-info btn-xs" @click="openDetail(data)">
                                Detail
                            </button>
                        </td>
                    </tr>
                    <tr v-show="loadingData == false && dataNsb.length == 0">
                        <td class="text-center" colspan="8">No Data</td>
                    </tr>
                </tbody>
            </table>
            <b-pagination
                v-model="currentPage"
                :total-rows="count_data"
                :per-page="perPage"
                aria-controls="new-table"
                v-show="count_data > perPage"
                @change="handlePageChange"
            ></b-pagination>
        </div>
        <b-modal title="Detail Audit" ref="detail-audit">
            <h6>Nasabah</h6>
            <div class="wrap-content-detail">
                <span>Nama</span>
                <span>{{ detailAudit.fullname }}</span>
            </div>
            <div class="wrap-content-detail">
                <span>Status</span>
                <span>{{ detailAudit.status }}</span>
            </div>
            <div class="wrap-content-detail" v-if="detailAudit.description">
                <span>Deskripsi</span>
                <span>{{ detailAudit.description }}</span>
            </div>

            <h6 class="mt-4">Penerima</h6>
            <div class="wrap-content-detail">
                <span>Nama</span>
                <span>{{ detailAudit.operator_id ? detailAudit.operator_id.fullname : "" }}</span>
            </div>
            <div class="wrap-content-detail">
                <span>Email</span>
                <span>{{ detailAudit.operator_id ? detailAudit.operator_id.email : "" }}</span>
            </div>
            <div class="wrap-content-detail">
                <span>No Telepon</span>
                <span>{{ detailAudit.operator_id ? detailAudit.operator_id.phonenumber : "" }}</span>
            </div>
            <div class="wrap-content-detail">
                <span>Info</span>
                <span
                    >{{ detailAudit.newInfo ? detailAudit.newInfo.cityData[0].city + ", " + detailAudit.newInfo.cityData[0].province : "" }} /
                    {{ detailAudit.newInfo ? detailAudit.newInfo.userIP : "" }}</span
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            dataNsb: [],
            number: 1,
            currentPage: 1,
            perPage: 10,
            count_data: "",
            loadingData: false,
            dataInfo: [],
            statusNsb: "",
            detailAudit: "",
        };
    },

    mounted() {
        this.getData(this.currentPage);
    },
    methods: {
        openDetail(dataDetail) {
            this.detailAudit = "";
            this.$refs["detail-audit"].show();
            axios.get("/v2/superadmin/operator-activity/" + dataDetail._id).then((res) => {
                this.detailAudit = res.data.data.operatorActivity;
                let newInfo;
                if (this.detailAudit.info) {
                    newInfo = JSON.parse(this.detailAudit.info);
                    this.detailAudit.newInfo = newInfo;
                }
            });
        },
        handlePageChange(value) {
            this.getData(value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        getData(offset) {
            let setPage = (offset - 1) * this.perPage;
            this.loadingData = true;
            axios.get("/v2/superadmin/operator-activity?limit=" + this.perPage + "&offset=" + setPage).then((res) => {
                this.loadingData = false;
                this.dataNsb = res.data.data.operatorActivity;
                this.count_data = res.data.data.total;
                for (let i = 0; i < this.dataNsb.length; i++) {
                    let newInfo;
                    if (this.dataNsb[i].info != undefined) {
                        newInfo = JSON.parse(this.dataNsb[i].info);
                        this.dataNsb[i].newInfo = newInfo;
                    }
                }
            });
        },
    },

    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
        paginate() {
            if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
                return;
            }
            var index = this.currentPage * this.perPage - this.perPage;
            return this.dataNsb.slice(index, index + this.perPage);
        },
    },
};
</script>

<style scoped>
.wrap-content-detail {
    display: flex;
    gap: 2;
}

.wrap-content-detail span:first-child {
    width: 6rem;
}
.wrap-content-detail span:last-child {
    font-weight: 640;
    font-size: 14px;
}

.lds-ring {
    display: inline-block;
    /* position: absolute; */
    width: 30px;
    height: 30px;
    /* top: 4px; */
    /* left: 39%; */
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 6px;
    border: 6px solid #1f354a;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

table {
    color: #707070 !important;
}

.nasabah {
    font-size: 14px;
    padding: 0 20px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 60px;
}
</style>
